import { TrackHistoryRequestInputSchema } from '@terra/shared-dto-chat-types';
import type { HttpHitlDisplayArgs } from './http-hitl-payload.utils';

export async function resolveTrackHistoryRequestHitlApprovalBlocked({
  args,
  fetchHistoryRequestForHitlDisplay,
}: {
  args: Record<string, unknown>;
  fetchHistoryRequestForHitlDisplay?: (
    requestId: string,
  ) => Promise<HttpHitlDisplayArgs | null>;
}): Promise<{ blocked: boolean }> {
  const parsedInput = TrackHistoryRequestInputSchema.safeParse(args);
  if (!parsedInput.success) {
    return { blocked: true };
  }

  if (!fetchHistoryRequestForHitlDisplay) {
    return { blocked: true };
  }

  const loadedArgs = await fetchHistoryRequestForHitlDisplay(
    parsedInput.data.requestId,
  );

  if (!loadedArgs) {
    return { blocked: true };
  }

  if (loadedArgs.wasProxyModified) {
    return { blocked: true };
  }

  if (
    loadedArgs.statusCode === 404 &&
    !parsedInput.data.allowNotFoundResponse
  ) {
    return { blocked: true };
  }

  return { blocked: false };
}
